export default "__VITE_ASSET__DP1SUrg4__"